/* eslint func-names: 0 */
/**
 * @constructor
 */
export const Env = function () {

  /**
   * @type {string}
   */
  this.appName = process.env.MIX_APP_NAME;

  /**
   * @type {string}
   */
  this.appApiUrl = process.env.MIX_APP_API_URL;

  /**
   * @type {string}
   */
  this.cdnCommonPath = process.env.MIX_CDN_COMMON_URL.replace(/\/+$/, '') + '/';

  /**
   * @type {string}
   */
  this.cdnStorePath = process.env.MIX_CDN_STORE_URL.replace(/\/+$/, '') + '/';

  /**
   *
   * @type {string}
   */
  this.cdnJsLibPath = process.env.MIX_CDN_JS_LIBS_PATH.replace(/\/+$/, '') + '/';

  /**
   * @type {string}
   */
  this.appId = process.env.MIX_APP_ID;

  /**
   * @type {string}
   */
  this.installmentTag = process.env.MIX_INSTALLMENT_TAG;

};